/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  refreshWhatsappAvatar(id) {
    return axios.post(`${this.url}/${id}/refresh_whatsapp_avatar`);
  }
}

export default new Agents();
